module.exports = __webpack_public_path__ + "static/media/DecCreditCard.guaranteed-rate.4db16393.png";